import { createSlice } from '@reduxjs/toolkit';
/**
 * screen: log|cnf|wel|act|rwd|ldb|uns|end
 */
const initialState = {
    wcode: null,
    lpurl: null,
    name: null,
    deadline: null,
    hasDeadline: null,
    hasRecurring: null,
    company: null,
    curComponent: null,
    viewport: 'D',
    screens: [],
};

const leSlice = createSlice({
    name: "pkzle",
    initialState,
    reducers: {
        fill(state, action) {
            state.wcode = action.payload.code;
            state.lpurl = action.payload.lp;
            state.name = action.payload.name;
            state.company = action.payload.company;
            state.screens = action.payload.screens;
            state.deadline = action.payload.deadline;
            state.hasDeadline = action.payload.has_deadline;
            state.hasRecurring = action.payload.recurring;

        },
        fuse(state, action) {
            const {property, value} = action.payload;
            state[property] = value;
        },
        setScreen(state, action) {
            const { type, is_active } = action.payload;
            const screenIndex = state.screens.findIndex(screen => screen.type === type);
            if (screenIndex !== -1) {
                state.screens[screenIndex].is_active = is_active;
            }
        },
        setScreenLocalName(state, action) {
            const { type, local_name } = action.payload;
            const screenIndex = state.screens.findIndex(screen => screen.type === type);
            if (screenIndex !== -1) {
                state.screens[screenIndex].local_name = local_name;
            }
        }        
    }
});

export default leSlice.reducer;
export { leSlice };